<title>{{ NDCProductUpdateNotificationsPage.htmlTitle }}</title>
<div class="row">
  <div class="col-sm-2 col-md-3 col-sm-4">
    <label class="smlx">Start Date</label>
    <input class="form-input indate" id="startDate" name="startDate" #startDate type="date" [value]="fromDate" />
  </div>

  <div class="col-sm-2 col-md-3 col-sm-4">
    <label class="smlx">End Date</label>
    <input class="form-input indate" id="endDate" name="ddate2" type="date" #endDate [value]="toDate" />
  </div>

  <div class="col-sm-2 col-md-3 col-sm-4">
    <br />
    <button class="ba-btn ba-btn-thin vsml" role="button" type="button"
      (click)="getRevisionNoticesWithinTheRange(startDate.valueAsDate, endDate.valueAsDate)">
      <i class="fa fa-reload"></i> Update
    </button>
  </div>
</div>
<app-ndc-product-update-notifications-page-table-section *ngIf="!filterButtonUsed"
  [tableData]="tableDataToDisplayOnPageFirstLoad"
  [productUpdateNoteFound]="NDCProductUpdateNotificationsPage.productUpdateNotFound"></app-ndc-product-update-notifications-page-table-section>

<app-ndc-product-update-notifications-page-table-section *ngIf="filterButtonUsed" [tableData]="tableDataFilteredByData"
  [productUpdateNoteFound]="NDCProductUpdateNotificationsPage.productUpdateNotFound"
  [showItemsWithoutReversingOrder]="true"></app-ndc-product-update-notifications-page-table-section>

<div class="subscribeLink">
  <button class="subscribeMe" *ngIf="isUserLoggedIn && !productUpdateSubscribed"><i class="fa fa-envelope"></i><a
      href="/profile">Subscribe Notifications</a></button>
  <button class="subscribeMe" *ngIf="!isUserLoggedIn" data-bs-toggle="modal" (click)="openLoginModal()"><i
      class="fa fa-envelope"></i> Subscribe Notifications</button>
  <button class="subscribeMe-green" *ngIf="productUpdateSubscribed && isUserLoggedIn"><i class="fa fa-bell"></i><a
      href="/profile">Subscribed</a></button>
</div>